const s = {
  name: "Contactless",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14.8,15.8C15.6,17,16,18.4,16,20c0,1.6-0.4,3-1.2,4.2l-1.7-1.1c0.6-0.9,0.9-2,0.9-3.2c0-1.2-0.3-2.3-0.9-3.2
			L14.8,15.8z"/>
		<path class="st0" d="M17.3,14.2c1.1,1.7,1.7,3.7,1.7,5.8c0,2.1-0.6,4.1-1.7,5.8l1.7,1.1c1.3-2,2-4.4,2-6.9c0-2.5-0.7-4.9-2-6.9
			L17.3,14.2z"/>
		<path class="st0" d="M24,20c0-3.1-0.9-6-2.4-8.5l1.7-1.1c1.7,2.8,2.7,6,2.7,9.5s-1,6.8-2.7,9.5l-1.7-1.1C23.1,26,24,23.1,24,20z"
			/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20
			c0,9.9,8.1,18,18,18s18-8.1,18-18C38,10.1,29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Contactless
};
